import Nullstack from 'nullstack';
export default function IconCircleChevronsUp({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-circle-chevrons-up",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M9 15l3 -3l3 3"
  }), "   ", Nullstack.element("path", {
    d: "M9 11l3 -3l3 3"
  }), "   ", Nullstack.element("path", {
    d: "M12 21a9 9 0 1 0 -.265 -.004l.265 .004z"
  }), " ");
}